// External libraries
import { css } from '@emotion/core';

// Internal modules
import {
  DISABLED_BACKGROUND_COLOR,
  DISABLED_BORDER_COLOR,
  HEADER_COLOR,
  TEXT_COLOR,
} from '@/styles';

const addressHeaderStyles = css`
  color: ${HEADER_COLOR};
  font-size: calc(1em * (14 / 16));
  font-weight: 600;
  line-height: 1.33;
  margin-bottom: 12px;

  @media (min-width: 365px) {
    font-size: calc(1em * (15 / 16));
  }
`;

const checkboxStyles = {
  containerStyleOverrides: css`
    margin-bottom: 16px;

    @media (min-width: 365px) {
      margin-bottom: 24px;
    }
  `,

  labelStyleOverrides: css`
    color: ${TEXT_COLOR};
    font-size: 15px;
  `,
};

const countryContainerStyleOverrides = css`
  background-color: ${DISABLED_BACKGROUND_COLOR};
  border-color: ${DISABLED_BORDER_COLOR};

  > select {
    color: ${HEADER_COLOR};
  }
`;

const getFieldsetStyles = ({ hasShipToBillingCheckbox, isBilling }) => css`
  margin-bottom: 16px;

  @media (min-width: 365px) {
    margin-bottom: ${hasShipToBillingCheckbox && isBilling ? 18 : 24}px;
  }

  /**
   * We are setting the 'margin-bottom' on the container, so the last child of
   * the container doesn't need to have a 'margin-bottom' property.
   */
  > div:not(:last-child) {
    margin-bottom: 12px;
  }
`;

const pageInfoStyleOverrides = {
  container: css({ marginBottom: '12px' }),
  message: css({ fontWeight: 'normal' }),
};

export {
  addressHeaderStyles,
  checkboxStyles,
  countryContainerStyleOverrides,
  getFieldsetStyles,
  pageInfoStyleOverrides,
};
